"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _hotspot2 = require("../../hotspot.utils");

var _StandardTail = require("./StandardTail.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StandardTail = /*#__PURE__*/function (_React$Component) {
  _inherits(StandardTail, _React$Component);

  function StandardTail() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StandardTail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StandardTail)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      tailWrapperDimensions: null,
      tailDimensions: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.getPoints();

      window.addEventListener('resize', (0, _hotspot2.debounce)(_this.getPoints, 1));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (oldProps) {
      var newProps = _this.props;

      if (oldProps.containerStyles !== newProps.containerStyles) {
        _this.getPoints();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', (0, _hotspot2.debounce)(_this.getPoints));
    });

    _defineProperty(_assertThisInitialized(_this), "getPoints", function () {
      if (!_this.clickableArea) {
        return null;
      }

      var containerDimensions = _this.clickableArea.parentElement.getBoundingClientRect();

      var anchorDimensions = _this.anchor.getBoundingClientRect();

      var nameDimensions = _this.name.getBoundingClientRect();

      var anchorMiddle = {
        x: anchorDimensions.left + anchorDimensions.width / 2 - containerDimensions.left,
        y: anchorDimensions.top + anchorDimensions.height / 2 - containerDimensions.top
      };
      var nameMiddle = {
        x: nameDimensions.left + nameDimensions.width / 2 - containerDimensions.left,
        y: nameDimensions.top + nameDimensions.height / 2 - containerDimensions.top
      };
      var left = Math.min(anchorMiddle.x, nameMiddle.x);
      var top = Math.min(anchorMiddle.y, nameMiddle.y);
      var height = Math.max(anchorMiddle.y - nameMiddle.y, nameMiddle.y - anchorMiddle.y);
      var width = Math.max(anchorMiddle.x - nameMiddle.x, nameMiddle.x - anchorMiddle.x);
      var tailDimensions;

      if (anchorMiddle.x < nameMiddle.x && anchorMiddle.y < nameMiddle.y) {
        tailDimensions = {
          x1: width,
          y1: height,
          x2: 0,
          y2: 0
        };
      } else if (anchorMiddle.x >= nameMiddle.x && anchorMiddle.y < nameMiddle.y) {
        tailDimensions = {
          x1: 0,
          y1: height,
          x2: width,
          y2: 0
        };
      } else if (anchorMiddle.x >= nameMiddle.x && anchorMiddle.y >= nameMiddle.y) {
        tailDimensions = {
          x1: 0,
          y1: 0,
          x2: width,
          y2: height
        };
      } else if (anchorMiddle.x < nameMiddle.x && anchorMiddle.y >= nameMiddle.y) {
        tailDimensions = {
          x1: width,
          y1: 0,
          x2: 0,
          y2: height
        };
      }

      _this.setState({
        tailWrapperDimensions: {
          height: height,
          left: left,
          top: top,
          width: width
        },
        tailDimensions: tailDimensions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "anchor", void 0);

    _defineProperty(_assertThisInitialized(_this), "clickableArea", void 0);

    _defineProperty(_assertThisInitialized(_this), "name", void 0);

    return _this;
  }

  _createClass(StandardTail, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          config = _this$props.config,
          containerStyles = _this$props.containerStyles,
          iconPosition = _this$props.iconPosition,
          name = _this$props.name,
          onClick = _this$props.onClick,
          playing = _this$props.playing,
          previewHoverState = _this$props.previewHoverState,
          shouldFadeOut = _this$props.shouldFadeOut,
          hideAnchor = _this$props.hideAnchor,
          customPlayer = _this$props.customPlayer;
      var _this$state = this.state,
          tailWrapperDimensions = _this$state.tailWrapperDimensions,
          tailDimensions = _this$state.tailDimensions;
      var standardTailConfig = config || _hotspot.standardTail;
      var ariaLabel = "".concat(name, " hotspot");
      return _react.default.createElement(_StandardTail.StandardTailClickableArea, {
        hotspotOpacity: standardTailConfig.opacity,
        onClick: onClick,
        playing: playing,
        previewHoverState: previewHoverState,
        ref: function ref(el) {
          return _this2.clickableArea = el;
        },
        shouldFadeOut: shouldFadeOut // aria-label={ariaLabel}

      }, tailWrapperDimensions && tailDimensions && _react.default.createElement(_StandardTail.TailWrapper, _extends({}, tailWrapperDimensions, {
        hideAnchor: hideAnchor
      }), _react.default.createElement(_StandardTail.Tail, _extends({
        stroke: standardTailConfig.borderColor
      }, tailDimensions))), _react.default.createElement(_StandardTail.StandardTailBoundingBox, {
        config: standardTailConfig,
        dimensions: containerStyles,
        hideAnchor: hideAnchor,
        customPlayer: customPlayer
      }, _react.default.createElement(_StandardTail.StandardTailAnchor, {
        config: standardTailConfig,
        ref: function ref(el) {
          return _this2.anchor = el;
        }
      })), iconPosition && _react.default.createElement(_StandardTail.StandardTailName, {
        config: standardTailConfig,
        position: iconPosition,
        ref: function ref(el) {
          return _this2.name = el;
        },
        "aria-label": ariaLabel,
        customPlayer: customPlayer
      }, name));
    }
  }]);

  return StandardTail;
}(_react.default.Component);

var _default = StandardTail;
exports.default = _default;